import React, { useState } from 'react';
import { useAuthFetch } from '../../hooks/useAuthFetch';

function FreeTextAnswerForm({ correctAnswer, onDone, disabled }) {
  const { authFetch } = useAuthFetch();
  const [text1, setText1] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const similarityLabel = result !== null
    ? result >= 0.9 ? 'high' : result >= 0.6 ? 'medium' : 'low'
    : null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const payload = {
        text1: text1.trim().toLowerCase(),
        text2: correctAnswer.trim().toLowerCase(),
      };
      if (!payload.text1 || !payload.text2) throw new Error('Both text fields are required.');
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000);
      const res = await authFetch(`${process.env.REACT_APP_API_URL}/api/compute-similarity`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });
      clearTimeout(timeoutId);
      const data = await res.json();
      if (data.error) throw new Error(data.error);
      setResult(data.similarity);
      onDone(data.similarity);
    } catch (err) {
      console.error('Error computing similarity:', err);
      if (err.name === 'AbortError') setError('Request timed out. Please try again.');
      else if (err.message) setError(err.message);
      else setError('An unexpected error occurred.');
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    onDone(null);
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="study-answer-form">
        <input
          className="study-answer-input"
          type="text"
          value={text1}
          onChange={(e) => setText1(e.target.value)}
          placeholder="Type your answer…"
          required
          disabled={disabled}
          data-form-type="other"
        />
        <button className="study-btn-primary" type="submit" disabled={loading || disabled}>
          {loading ? 'Checking…' : 'Submit'}
        </button>
        <button className="study-btn-ghost" type="button" onClick={handleSkip} disabled={disabled}>
          Skip
        </button>
      </form>

      {error && <p style={{ fontSize: 13, color: '#f87171', marginBottom: 12 }}>{error}</p>}

      {result !== null && (
        <div className={`study-similarity-badge ${similarityLabel}`}>
          {similarityLabel === 'high' ? '✓' : similarityLabel === 'medium' ? '~' : '✗'}
          &nbsp;{(result * 100).toFixed(0)}% match
        </div>
      )}
    </>
  );
}

export default FreeTextAnswerForm;
